import yup from './yup'

export const sponsorshipLevelFormSchema = yup.object().shape({
  tierName: yup.string().label('Tier Name').trimmedRequired('Tier Name is a required field'),
  sponsorshipTier: yup
    .number()
    .integer()
    .positive()
    .label('Sponsorship Tier')
    .typeError('Sponsorship Tier should be a positive number')
    .required(),
  allowLogo: yup.boolean().default(false),
  allowAdBanner: yup.boolean().default(false),
  allowBrochure: yup.boolean().default(false)
})
